import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { Router } from '@angular/router';
import { HeaderComponent } from '../../login/header/header.component';
import { AssistantsComponent } from '../assistants/assistants.component';

@Component({
  selector: 'app-dashboard',
  imports: [
    CommonModule,
    HeaderComponent,
    MatButtonModule,
    AssistantsComponent,
    MatDividerModule,
    AssistantsComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  animations: [
    trigger('fade', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate('600ms ease-in', style({ opacity: 1 }))]),
    ]),
  ],
})
export class DashboardComponent {
  cards = [
    {
      header: 'Study Buddy',
      description: 'Chat with Study Buddy for instant help on any topic',
      route: '/chat',
    },
    {
      header: 'Workspaces',
      description: 'Join team or school specific workspaces and classrooms',
      route: '/workspaces',
    },
    {
      header: 'Tutors',
      description: 'Explore tailored AI tutors for various subjects',
      route: '/tutors',
    },
    {
      header: 'Conversations',
      description: 'Review and revisit all your past lessons and chats',
      route: '/conversations',
    },
  ];

  showAssistants = false;
  showCards = true;

  constructor(private router: Router) { }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }
}
